import React, { Component } from 'react';

class NotFoundPage extends Component {
  render() {
    return (
      <h3>Couldn't find the resource you're looking for</h3>
    );
  }
}

export default NotFoundPage;
